import React, { useState } from "react";
import { EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { EditDynamicSubtitleAside } from "./EditDynamicSubtilteAside";

export interface EditDynamicSubtitleButtonAsideProps {
    fileRecordId: string;
    isDisabled: boolean;
    isLabeled?: boolean;
}

export const EditDynamicSubtitleButtonAside: React.FunctionComponent<EditDynamicSubtitleButtonAsideProps> = (
    props: EditDynamicSubtitleButtonAsideProps
) => {
    const { fileRecordId, isLabeled, isDisabled } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                testId="edit-dynamic-subtitle"
                disabled={isDisabled}
            />
            <EditDynamicSubtitleAside
                fileRecordId={fileRecordId}
                isOpen={isOpen}
                onCancel={onClose}
                onSubmit={onClose}
            />
        </AuthorizationWrapper>
    );
};
